export default __webpack_public_path__ + "images/account-manager-dummy-140.4186f8297fa381265a29ab65414b0eb1.svg";